import moment from 'moment';
import { formatToCode } from './moment-date-utils';

export function buildRangeToday() {
  const currentDate = moment();
  const initialDate = formatToCode(currentDate);
  return {
    initialDate,
    finalDate: initialDate,
  };
}

export function buildRangeThisWeek() {
  const currentDate = formatToCode(moment());
  const initialDate = formatToCode(moment().startOf('week'));
  return {
    initialDate,
    finalDate: currentDate,
  };
}

export function buildRangeThisMonth() {
  const currentDate = formatToCode(moment());
  const initialDate = formatToCode(moment().startOf('month'));
  return {
    initialDate,
    finalDate: currentDate,
  };
}

export function buildRangeLastMonth() {
  const currentDate = formatToCode(moment().subtract(1, 'months').endOf('month'));
  const initialDate = formatToCode(moment().subtract(1, 'months').startOf('month'));
  return {
    initialDate,
    finalDate: currentDate,
  };
}

export function buildRangeLast6Months() {
  const currentDate = formatToCode(moment());
  const initialDate = formatToCode(moment().subtract(6, 'months').startOf('month'));
  return {
    initialDate,
    finalDate: currentDate,
  };
}
